import $ from "jquery";
import _ from "lodash";
import ko from "knockout";
import config from "config";
import loggingService from "services/loggingService";
import serverLogger from "services/serverLogger";
import requestTracker from "services/activeRequestTracker";
import PubSub from "util/PubSub";

let initialized = false;
const payloadQueue = [];

function flushQueue() {
    _.each(payloadQueue, sendPayload);
}

function parseUrl(location) {
    const link = document.createElement("a");
    link.href = location;
    return link;
}

function getMessageLocation(newLocation) {
    if (isFullUrl(newLocation)) {
        const newUrl = parseUrl(newLocation);
        const currentUrl = parseUrl(window.location.href);
        if (isSamePage(currentUrl, newUrl)) {
            return newUrl.hash;
        }
    }

    return newLocation;
}

function isFullUrl(location) {
    return /^http/.test(location);
}

function isSamePage(url1, url2) {
    return (
        url1.protocol === url2.protocol &&
        url1.host === url2.host &&
        url1.pathname == url2.pathname &&
        url1.search === url2.search
    );
}

function queuePayload(payload) {
    payloadQueue.push(payload);
}

function sendMessage(type, data, options) {
    options = options || {};
    const message = {
        type: type,
        data: data,
        options: options,
    };

    if (initialized || message.type == "initialized") {
        sendPayload(message);
    } else {
        queuePayload(message);
    }
}

const messageHandlers = {
    publish: function (data) {
        const topicName = data.topic;
        const topicData = data.data;
        PubSub.Topic(topicName).publish(topicData);
    },
    logout: function () {
        requestTracker.isLoggedIn(false);
        requestTracker.isOAuthSessionExpired(false);
        serverLogger.isLoggedIn(false);
    },
    toast: function () {}, // define so we trace instead of warn
    "request-form-data": function () {}, // define so we trace instead of warn
};

function triggerMessageAction(type, data) {
    if (messageHandlers[type]) {
        loggingService.trace("Handling message type", type, data);
        messageHandlers[type].call(null, data);
    } else {
        loggingService.warn("Unknown message type", type, data);
    }
}

function handleMessageEvent(event) {
    const messageEvent = event.originalEvent;
    const messageData = messageEvent.data;
    if (messageEvent.source === window.parent && messageData.type) {
        triggerMessageAction(messageData.type.toLowerCase(), messageData.data);
    }
}

function sendPayload(payload) {
    loggingService.trace("Sending message to", config.embeddingOrigin, payload);
    window.parent.postMessage(payload, config.embeddingOrigin);
}

function setInitialized() {
    initialized = true;
    flushQueue();
}

const embeddingService = {
    currentBreadcrumbArray: ko.observableArray(),

    invalidateSession: function () {
        sendMessage("invalidatesession");
    },

    requestLogout: function () {
        sendMessage("logout");
    },

    requestNavigation: function (newLocation, options) {
        options = options || {};
        const location = getMessageLocation(newLocation);
        sendMessage("navigation", location, options);
    },

    requestRedirect: function (newLocation) {
        const location = getMessageLocation(newLocation);
        sendMessage("redirect", location);
    },

    requestCloseEvaluation: function () {
        sendMessage("sidepanel-closed");
    },

    notifyInitialized: function () {
        sendMessage("initialized");
        setInitialized();
    },

    sendToastNotification: function (toast) {
        sendMessage("toast", toast);
    },

    sendDocumentFax: function (documentData) {
        sendMessage("documentFax", JSON.stringify(documentData));
    },

    registerNavigation: function (navTree) {
        sendMessage("registernav", navTree);
    },

    notifyInteracting: function (interacting) {
        sendMessage("interaction", interacting);
    },

    notifyNewBreadCrumbs: function (breadcrumb) {
        if (!_.isEqual(breadcrumb, this.currentBreadcrumbArray())) {
            this.currentBreadcrumbArray(breadcrumb);
            sendMessage("breadcrumb", breadcrumb);
        }
    },

    notifyACDInteractions: function (count) {
        sendMessage("acd", count);
    },

    notifyIsNotResponding: function (isNotResponding) {
        sendMessage("responding", !isNotResponding);
    },

    showPhoneSelection: function () {
        sendMessage("phone");
    },

    notifyAlerts: function (alertData) {
        sendMessage("alerting", alertData);
    },

    listenForMessages: function () {
        $(window).on("message", _.bind(handleMessageEvent, this));
    },

    notifyBackNavigation: function () {
        sendMessage("back");
    },

    notifyHelpURL: function (helpURL) {
        sendMessage("helpurl", helpURL);
    },

    notifyEvaluationDeleted: function (evaluationId) {
        sendMessage("evaluation-deleted", evaluationId);
    },

    sendFormData: function (formData) {
        // JSON manipulation is required here as we need to remove unwanted functions from the form-data
        sendMessage("form-data", JSON.parse(JSON.stringify(formData)));
    },

    sendFormAnswers: function (answers) {
        // JSON manipulation is required here as we need to remove unwanted functions from the form-data
        sendMessage("form-answers", JSON.parse(JSON.stringify(answers)));
    },

    sendPassMarkPercentage: function (passMarkPercentage) {
        sendMessage("pass-mark-percentage", passMarkPercentage);
    },

    sendFormLoadedStatus: function (isLoaded) {
        sendMessage("form-loaded", isLoaded);
    },

    sendFormReadyStatus: function (isReady) {
        sendMessage("form-ready", isReady);
    },

    notifyErrors: function (errorData) {
        sendMessage("notify-errors", errorData);
    },
    postJumpToLocation: function (location) {
        sendPayload({
            key: "jumpToLocation",
            transfer: location,
        });
    },
    postScrollTranscriptToPhrase: function (topicNumber) {
        sendPayload({
            key: "evaluationViewPhraseSelect",
            topicNumber: topicNumber,
        });
    },
    postScrollTranscriptToEmailPhrase: function (
        offsetWords,
        topicPhrase,
        startTimeMs
    ) {
        sendPayload({
            key: "evaluationViewPhraseSelect",
            emailPhrase: {
                offsetWords,
                topicPhrase,
                startTimeMs,
            },
        });
    },
};

// Request login if OAuth Session is invalid
ko.computed(function () {
    if (requestTracker.isOAuthSessionExpired()) {
        embeddingService.requestLogout();
    }
});

embeddingService.listenForMessages();

export default embeddingService;
